var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "lottery-config-pane",
    },
    [
      _c(
        "el-form",
        {
          ref: "lotteryForm",
          staticClass: "lottery-form",
          attrs: {
            model: _vm.formData,
            rules: _vm.formRules,
            "label-width": "110px",
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "config-tabs",
              attrs: { type: "border-card" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "主题设置", name: "theme" } },
                [
                  _c(
                    "div",
                    { staticClass: "tab-content" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动标题", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入活动标题",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "title", $$v)
                              },
                              expression: "formData.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("主题配色"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "前景色" } }, [
                        _c(
                          "div",
                          { staticClass: "color-picker-row" },
                          [
                            _c("el-color-picker", {
                              attrs: { "color-format": "hex" },
                              model: {
                                value: _vm.formData.theme.fgColor,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData.theme, "fgColor", $$v)
                                },
                                expression: "formData.theme.fgColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "color-input-inline",
                              attrs: { placeholder: "#98CAC1" },
                              model: {
                                value: _vm.formData.theme.fgColor,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData.theme, "fgColor", $$v)
                                },
                                expression: "formData.theme.fgColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "color-preview-box",
                              style: {
                                backgroundColor: _vm.formData.theme.fgColor,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "背景色" } }, [
                        _c(
                          "div",
                          { staticClass: "color-picker-row" },
                          [
                            _c("el-color-picker", {
                              attrs: { "color-format": "hex" },
                              model: {
                                value: _vm.formData.theme.bgColor,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData.theme, "bgColor", $$v)
                                },
                                expression: "formData.theme.bgColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "color-input-inline",
                              attrs: { placeholder: "#1A4D38" },
                              model: {
                                value: _vm.formData.theme.bgColor,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData.theme, "bgColor", $$v)
                                },
                                expression: "formData.theme.bgColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "color-preview-box",
                              style: {
                                backgroundColor: _vm.formData.theme.bgColor,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "按钮色" } }, [
                        _c(
                          "div",
                          { staticClass: "color-picker-row" },
                          [
                            _c("el-color-picker", {
                              attrs: { "color-format": "hex" },
                              model: {
                                value: _vm.formData.theme.btnColor,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData.theme, "btnColor", $$v)
                                },
                                expression: "formData.theme.btnColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "color-input-inline",
                              attrs: { placeholder: "#FF6B6B" },
                              model: {
                                value: _vm.formData.theme.btnColor,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData.theme, "btnColor", $$v)
                                },
                                expression: "formData.theme.btnColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "color-preview-box",
                              style: {
                                backgroundColor: _vm.formData.theme.btnColor,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "按钮渐变色" } }, [
                        _c(
                          "div",
                          { staticClass: "color-picker-row" },
                          [
                            _c("el-color-picker", {
                              attrs: { "color-format": "hex" },
                              model: {
                                value: _vm.formData.theme.btnGradientColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.theme,
                                    "btnGradientColor",
                                    $$v
                                  )
                                },
                                expression: "formData.theme.btnGradientColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "color-input-inline",
                              attrs: { placeholder: "#FF8E8E" },
                              model: {
                                value: _vm.formData.theme.btnGradientColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.theme,
                                    "btnGradientColor",
                                    $$v
                                  )
                                },
                                expression: "formData.theme.btnGradientColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "color-preview-box",
                              style: {
                                backgroundColor:
                                  _vm.formData.theme.btnGradientColor,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "按钮文字色" } }, [
                        _c(
                          "div",
                          { staticClass: "color-picker-row" },
                          [
                            _c("el-color-picker", {
                              attrs: { "color-format": "hex" },
                              model: {
                                value: _vm.formData.theme.btnTextColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.theme,
                                    "btnTextColor",
                                    $$v
                                  )
                                },
                                expression: "formData.theme.btnTextColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "color-input-inline",
                              attrs: { placeholder: "#FFFFFF" },
                              model: {
                                value: _vm.formData.theme.btnTextColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.theme,
                                    "btnTextColor",
                                    $$v
                                  )
                                },
                                expression: "formData.theme.btnTextColor",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "color-preview-box",
                              style: {
                                backgroundColor:
                                  _vm.formData.theme.btnTextColor,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "背景图" } }, [
                        _c(
                          "div",
                          { staticClass: "upload-section" },
                          [
                            _c("image-upload", {
                              staticClass: "banner-upload",
                              attrs: { prefix: _vm.imagePrefix },
                              model: {
                                value: _vm.formData.bgUrl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "bgUrl", $$v)
                                },
                                expression: "formData.bgUrl",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "upload-tip" }, [
                              _vm._v("推荐尺寸：686px × 160px"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("广告设置"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "广告图" } }, [
                        _c(
                          "div",
                          { staticClass: "upload-section" },
                          [
                            _c("image-upload", {
                              staticClass: "banner-upload",
                              attrs: { prefix: _vm.imagePrefix },
                              model: {
                                value: _vm.formData.bannerUrl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "bannerUrl", $$v)
                                },
                                expression: "formData.bannerUrl",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "upload-tip" }, [
                              _vm._v("推荐尺寸：686px × 160px"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("分享设置"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "分享标题" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入分享标题",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.shareTitle,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "shareTitle", $$v)
                              },
                              expression: "formData.shareTitle",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "分享卡片图" } }, [
                        _c(
                          "div",
                          { staticClass: "upload-section" },
                          [
                            _c("image-upload", {
                              staticClass: "share-upload",
                              attrs: { prefix: _vm.imagePrefix },
                              model: {
                                value: _vm.formData.shareImgUrl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "shareImgUrl", $$v)
                                },
                                expression: "formData.shareImgUrl",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "upload-tip" }, [
                              _vm._v("推荐尺寸：686px × 375px"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("其他设置"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "显示位置" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.pos,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "pos", $$v)
                                },
                                expression: "formData.pos",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  "\n                积分\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(
                                  "\n                订单\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v(
                                  "\n                活动\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.pos === 2
                        ? _c("el-form-item", { attrs: { label: "选择门店" } }, [
                            _c(
                              "div",
                              { staticClass: "limit-config-item" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      icon: "el-icon-plus",
                                    },
                                    on: { click: _vm.openStoreSelector },
                                  },
                                  [
                                    _vm._v(
                                      "\n                选择门店\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.selectedStoreList.length > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "selected-count" },
                                      [
                                        _vm._v(
                                          "已选择 " +
                                            _vm._s(
                                              _vm.selectedStoreList.length
                                            ) +
                                            " 家门店"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.selectedStoreList.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "selected-goods-list" },
                                  _vm._l(
                                    _vm.selectedStoreList,
                                    function (store) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: store.id,
                                          staticStyle: { margin: "4px" },
                                          attrs: {
                                            closable: "",
                                            size: "small",
                                          },
                                          on: {
                                            close: function ($event) {
                                              return _vm.removeStore(store.id)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(store.storeName) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "field-tip field-tip-danger" },
                              [
                                _c("span", { staticClass: "tip-icon" }, [
                                  _vm._v("⚠"),
                                ]),
                                _vm._v(" 若不选择则默认全部门店\n            "),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否有效" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "有效",
                              "inactive-text": "无效",
                            },
                            model: {
                              value: _vm.formData.enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "enabled", $$v)
                              },
                              expression: "formData.enabled",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "medium",
                                loading: _vm.submitLoading,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [_vm._v("\n              确认\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "medium",
                                loading: _vm.submitLoading,
                              },
                              on: { click: _vm.handleValidate },
                            },
                            [_vm._v("\n              校验\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "medium" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("\n              重置\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "基本信息", name: "basic" } },
                [
                  _c(
                    "div",
                    { staticClass: "tab-content" },
                    [
                      _c("div", { staticClass: "alert-title-bar" }, [
                        _c("i", {
                          staticClass: "el-icon-warning",
                          staticStyle: {
                            color: "#E6A23C",
                            "font-size": "14px",
                            "margin-right": "6px",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "alert-title-text" }, [
                          _vm._v("资格判断说明"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tips-box" }, [
                        _c("div", { staticClass: "tips-content" }, [
                          _c("div", { staticClass: "tips-section" }, [
                            _c("p", { staticClass: "tips-section-title" }, [
                              _c("strong", [_vm._v("若启用资格判断：")]),
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v("前端小程序逻辑也随之启用，否则不生效"),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "扣除规则：先扣除资格，后按积分规则扣除"
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips-section" }, [
                            _c("p", { staticClass: "tips-section-title" }, [
                              _c("strong", [_vm._v("若不启用资格判断：")]),
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [_vm._v("直接按积分扣除规则")]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "tips-note" }, [
                            _vm._v(
                              "\n                以上逻辑，都受到'抽奖次数'限制\n              "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间", required: "" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "500px" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                            },
                            on: { change: _vm.handleDateChange },
                            model: {
                              value: _vm.dateRange,
                              callback: function ($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户类型" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.userType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "userType", $$v)
                                },
                                expression: "formData.userType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(
                                  "\n                不限\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  "\n                新用户\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(
                                  "\n                老用户\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.userType !== 1
                        ? _c("el-form-item", { attrs: { label: "用户级别" } }, [
                            _c(
                              "div",
                              { staticClass: "limit-config-item" },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.userRankList,
                                      callback: function ($$v) {
                                        _vm.userRankList = $$v
                                      },
                                      expression: "userRankList",
                                    },
                                  },
                                  _vm._l(_vm.userRankOptions, function (rank) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: rank.id,
                                        attrs: { label: rank.id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(rank.name) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "20px" },
                                    attrs: { size: "small", type: "text" },
                                    on: { click: _vm.selectAllUserRanks },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.isAllUserRanksSelected
                                            ? "取消全选"
                                            : "全选"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "每日重置" } }, [
                        _c(
                          "div",
                          { staticClass: "limit-config-item" },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-text": "启用",
                                "inactive-text": "禁用",
                              },
                              model: {
                                value: _vm.formData.dailyReset,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "dailyReset", $$v)
                                },
                                expression: "formData.dailyReset",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "field-tip" }, [
                              _vm._v("开启后每天赠送抽奖机会，否则活动赠送"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "企微用户" } }, [
                        _c(
                          "div",
                          { staticClass: "limit-config-item" },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-text": "启用",
                                "inactive-text": "禁用",
                              },
                              model: {
                                value: _vm.formData.isQwe,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "isQwe", $$v)
                                },
                                expression: "formData.isQwe",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "field-tip" }, [
                              _vm._v("开启后仅限企微用户参加"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("抽奖次数限制"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "总抽奖次数" } }, [
                        _c(
                          "div",
                          { staticClass: "limit-config-item" },
                          [
                            _c("el-switch", {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.limitEnabled.totalNum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.limitEnabled, "totalNum", $$v)
                                },
                                expression: "limitEnabled.totalNum",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input-number", {
                              staticStyle: {
                                width: "200px",
                                "margin-left": "16px",
                              },
                              attrs: {
                                min: 0,
                                max: 99999999,
                                disabled: !_vm.limitEnabled.totalNum,
                                "controls-position": "right",
                                size: "small",
                              },
                              model: {
                                value: _vm.formData.totalNum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "totalNum", $$v)
                                },
                                expression: "formData.totalNum",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "field-tip" }, [
                              _vm._v("设置为 0 表示不限制"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "每人总次数" } }, [
                        _c(
                          "div",
                          { staticClass: "limit-config-item" },
                          [
                            _c("el-switch", {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.limitEnabled.preMaxNum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.limitEnabled, "preMaxNum", $$v)
                                },
                                expression: "limitEnabled.preMaxNum",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input-number", {
                              staticStyle: {
                                width: "200px",
                                "margin-left": "16px",
                              },
                              attrs: {
                                min: 0,
                                max: 99999,
                                disabled: !_vm.limitEnabled.preMaxNum,
                                "controls-position": "right",
                                size: "small",
                              },
                              model: {
                                value: _vm.formData.preMaxNum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "preMaxNum", $$v)
                                },
                                expression: "formData.preMaxNum",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "field-tip" }, [
                              _vm._v("设置为 0 表示不限制"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "每人每日次数" } }, [
                        _c(
                          "div",
                          { staticClass: "limit-config-item" },
                          [
                            _c("el-switch", {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.limitEnabled.preDayMaxNum,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.limitEnabled,
                                    "preDayMaxNum",
                                    $$v
                                  )
                                },
                                expression: "limitEnabled.preDayMaxNum",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-input-number", {
                              staticStyle: {
                                width: "200px",
                                "margin-left": "16px",
                              },
                              attrs: {
                                min: 0,
                                max: 99999,
                                disabled: !_vm.limitEnabled.preDayMaxNum,
                                "controls-position": "right",
                                size: "small",
                              },
                              model: {
                                value: _vm.formData.preDayMaxNum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "preDayMaxNum", $$v)
                                },
                                expression: "formData.preDayMaxNum",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "field-tip" }, [
                              _vm._v("设置为 0 表示不限制"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("资格条件"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "启用资格判断" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "启用",
                              "inactive-text": "禁用",
                            },
                            model: {
                              value: _vm.formData.isCondition,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "isCondition", $$v)
                              },
                              expression: "formData.isCondition",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.isCondition === 1
                        ? [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.formData.dailyReset === 1
                                      ? "每日赠送"
                                      : "活动赠送",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "limit-config-item" },
                                  [
                                    _c("el-switch", {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.conditionEnabled.preDayGive,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.conditionEnabled,
                                            "preDayGive",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "conditionEnabled.preDayGive",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input-number", {
                                      staticStyle: {
                                        width: "200px",
                                        "margin-left": "16px",
                                      },
                                      attrs: {
                                        min: 0,
                                        max: 9999,
                                        disabled:
                                          !_vm.conditionEnabled.preDayGive,
                                        "controls-position": "right",
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.formData.preDayGive,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "preDayGive",
                                            $$v
                                          )
                                        },
                                        expression: "formData.preDayGive",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "field-tip" }, [
                                      _vm._v("次抽奖机会"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.formData.pos === 2
                              ? [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "消费金额",
                                        prop: "conditionConsume",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "limit-config-item" },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              min: 0,
                                              max: 999999,
                                              precision: 2,
                                              "controls-position": "right",
                                              size: "small",
                                            },
                                            model: {
                                              value:
                                                _vm.formData.conditionConsume,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "conditionConsume",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.conditionConsume",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "field-tip" },
                                            [
                                              _vm._v(
                                                "元，增加 1 次机会（=0 下单就送），" +
                                                  _vm._s(
                                                    _vm.formData.dailyReset ===
                                                      1
                                                      ? "每日最多"
                                                      : "活动最多"
                                                  )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticStyle: {
                                              width: "160px",
                                              "margin-left": "8px",
                                            },
                                            attrs: {
                                              min: 0,
                                              max: 9999,
                                              "controls-position": "right",
                                              size: "small",
                                            },
                                            model: {
                                              value:
                                                _vm.formData.consumeMaxTimes,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "consumeMaxTimes",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.consumeMaxTimes",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "field-tip" },
                                            [_vm._v("次（=0不限制）")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "订单是否实付" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "limit-config-item" },
                                        [
                                          _c("el-switch", {
                                            attrs: {
                                              "active-value": 1,
                                              "inactive-value": 0,
                                              "active-text": "启用",
                                              "inactive-text": "禁用",
                                            },
                                            model: {
                                              value: _vm.formData.orderReal,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "orderReal",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.orderReal",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "field-tip" },
                                            [
                                              _vm._v(
                                                "启用后计算订单的实付金额(不含优惠券等)"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "指定商品" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "limit-config-item",
                                            staticStyle: {
                                              "align-items": "flex-start",
                                            },
                                          },
                                          [
                                            _c("el-switch", {
                                              staticStyle: {
                                                "margin-top": "8px",
                                              },
                                              attrs: { size: "small" },
                                              model: {
                                                value:
                                                  _vm.conditionEnabled.goods,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.conditionEnabled,
                                                    "goods",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "conditionEnabled.goods",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-left": "16px",
                                                  flex: "1",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                      "margin-bottom": "8px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          icon: "el-icon-plus",
                                                          disabled:
                                                            !_vm
                                                              .conditionEnabled
                                                              .goods,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.openGoodsSelector,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          选择商品\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.conditionEnabled
                                                      .goods &&
                                                    _vm.selectedGoodsList
                                                      .length > 0
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "selected-count",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "已选择 " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedGoodsList
                                                                    .length
                                                                ) +
                                                                " 件商品"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("el-button", {
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                      },
                                                      attrs: {
                                                        size: "small",
                                                        icon: "el-icon-delete",
                                                        circle: "",
                                                        disabled:
                                                          !_vm.conditionEnabled
                                                            .goods ||
                                                          _vm.selectedGoodsList
                                                            .length === 0,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.handleClearGoods,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.selectedGoodsList.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm
                                                                .conditionEnabled
                                                                .goods,
                                                            expression:
                                                              "conditionEnabled.goods",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "selected-goods-list",
                                                      },
                                                      _vm._l(
                                                        _vm.selectedGoodsList,
                                                        function (goods) {
                                                          return _c(
                                                            "el-tag",
                                                            {
                                                              key: goods.id,
                                                              staticStyle: {
                                                                margin: "4px",
                                                              },
                                                              attrs: {
                                                                closable: "",
                                                                size: "small",
                                                              },
                                                              on: {
                                                                close:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeGoods(
                                                                      goods.id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    goods.goodsName
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "菜品分类" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "limit-config-item",
                                            staticStyle: {
                                              "align-items": "flex-start",
                                            },
                                          },
                                          [
                                            _c("el-switch", {
                                              staticStyle: {
                                                "margin-top": "8px",
                                              },
                                              attrs: { size: "small" },
                                              model: {
                                                value:
                                                  _vm.conditionEnabled.category,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.conditionEnabled,
                                                    "category",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "conditionEnabled.category",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-left": "16px",
                                                  flex: "1",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                      "margin-bottom": "8px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          icon: "el-icon-plus",
                                                          disabled:
                                                            !_vm
                                                              .conditionEnabled
                                                              .category,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.openCategorySelector,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          选择分类\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.conditionEnabled
                                                      .category &&
                                                    _vm.selectedCategoryList
                                                      .length > 0
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "selected-count",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "已选择 " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedCategoryList
                                                                    .length
                                                                ) +
                                                                " 个分类"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.selectedCategoryList
                                                  .length > 0 &&
                                                _vm.flatCategoryList.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm
                                                                .conditionEnabled
                                                                .category,
                                                            expression:
                                                              "conditionEnabled.category",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "selected-category-list",
                                                      },
                                                      _vm._l(
                                                        _vm.flatCategoryList,
                                                        function (cat) {
                                                          return _c(
                                                            "el-tag",
                                                            {
                                                              key: cat.id,
                                                              staticStyle: {
                                                                margin: "4px",
                                                              },
                                                              attrs: {
                                                                closable: "",
                                                                size: "small",
                                                              },
                                                              on: {
                                                                close:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeCategory(
                                                                      cat.id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    cat.label
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "订单场景" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "limit-config-item" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.formData.orderScenes,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "orderScenes",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.orderScenes",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-checkbox",
                                                  { attrs: { label: 1 } },
                                                  [
                                                    _vm._v(
                                                      "\n                        堂食\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-checkbox",
                                                  { attrs: { label: 2 } },
                                                  [
                                                    _vm._v(
                                                      "\n                        自提\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-checkbox",
                                                  { attrs: { label: 3 } },
                                                  [
                                                    _vm._v(
                                                      "\n                        外卖\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-left": "20px",
                                                },
                                                attrs: {
                                                  size: "small",
                                                  type: "text",
                                                },
                                                on: {
                                                  click:
                                                    _vm.selectAllOrderScenes,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.isAllOrderScenesSelected
                                                        ? "取消全选"
                                                        : "全选"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "邀请好友" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "limit-config-item" },
                                  [
                                    _c("el-switch", {
                                      attrs: { size: "small" },
                                      model: {
                                        value:
                                          _vm.conditionEnabled.conditionInvite,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.conditionEnabled,
                                            "conditionInvite",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "conditionEnabled.conditionInvite",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "field-tip",
                                        staticStyle: { "margin-left": "16px" },
                                      },
                                      [_vm._v("每邀请")]
                                    ),
                                    _vm._v(" "),
                                    _vm.conditionEnabled.conditionInvite
                                      ? _c("el-input-number", {
                                          staticStyle: {
                                            width: "160px",
                                            "margin-left": "8px",
                                          },
                                          attrs: {
                                            min: 0,
                                            max: 9999,
                                            disabled:
                                              !_vm.conditionEnabled
                                                .conditionInvite,
                                            "controls-position": "right",
                                            size: "small",
                                          },
                                          model: {
                                            value: _vm.formData.conditionInvite,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "conditionInvite",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.conditionInvite",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.conditionEnabled.conditionInvite
                                      ? _c(
                                          "span",
                                          { staticClass: "field-tip" },
                                          [
                                            _vm._v(
                                              "好友，增加1次机会，" +
                                                _vm._s(
                                                  _vm.formData.dailyReset === 1
                                                    ? "每日最多"
                                                    : "活动最多"
                                                )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.conditionEnabled.conditionInvite
                                      ? _c("el-input-number", {
                                          staticStyle: {
                                            width: "160px",
                                            "margin-left": "8px",
                                          },
                                          attrs: {
                                            min: 0,
                                            max: 9999,
                                            disabled:
                                              !_vm.conditionEnabled
                                                .conditionInvite,
                                            "controls-position": "right",
                                            size: "small",
                                          },
                                          model: {
                                            value: _vm.formData.inviteGiveTimes,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "inviteGiveTimes",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.inviteGiveTimes",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.conditionEnabled.conditionInvite
                                      ? _c(
                                          "span",
                                          { staticClass: "field-tip" },
                                          [_vm._v("次")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "企微赠送次数" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "limit-config-item" },
                                  [
                                    _c("el-switch", {
                                      attrs: { size: "small" },
                                      model: {
                                        value:
                                          _vm.conditionEnabled.weworkGiveTimes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.conditionEnabled,
                                            "weworkGiveTimes",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "conditionEnabled.weworkGiveTimes",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "field-tip",
                                        staticStyle: { "margin-left": "16px" },
                                      },
                                      [_vm._v("添加企微赠送")]
                                    ),
                                    _vm._v(" "),
                                    _vm.conditionEnabled.weworkGiveTimes
                                      ? _c("el-input-number", {
                                          staticStyle: {
                                            width: "200px",
                                            "margin-left": "8px",
                                          },
                                          attrs: {
                                            min: 0,
                                            max: 9999,
                                            disabled:
                                              !_vm.conditionEnabled
                                                .weworkGiveTimes,
                                            "controls-position": "right",
                                            size: "small",
                                          },
                                          model: {
                                            value: _vm.formData.weworkGiveTimes,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "weworkGiveTimes",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.weworkGiveTimes",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.conditionEnabled.weworkGiveTimes
                                      ? _c(
                                          "span",
                                          { staticClass: "field-tip" },
                                          [_vm._v("次")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [
                          _c("span", { staticClass: "divider-title" }, [
                            _vm._v("积分设置"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.formData.pos !== 2
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "消耗积分" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  min: 0,
                                  max: 999999,
                                  "controls-position": "right",
                                },
                                model: {
                                  value: _vm.formData.point,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "point", $$v)
                                  },
                                  expression: "formData.point",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "field-tip" }, [
                                _vm._v("设置为 0 表示免费抽奖"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动规则" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              placeholder: "请输入活动规则，每行一条规则",
                              maxlength: "1000",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.formData.rule,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "rule", $$v)
                              },
                              expression: "formData.rule",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "medium",
                                loading: _vm.submitLoading,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [_vm._v("\n              确认\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "medium",
                                loading: _vm.submitLoading,
                              },
                              on: { click: _vm.handleValidate },
                            },
                            [_vm._v("\n              校验\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "medium" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("\n              重置\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "奖品设置", name: "prize" } },
                [
                  _c(
                    "div",
                    { staticClass: "tab-content" },
                    [
                      _c(
                        "el-alert",
                        {
                          staticClass: "tips-alert",
                          attrs: {
                            title: "奖品设置说明",
                            type: "info",
                            closable: false,
                            "show-icon": "",
                          },
                        },
                        [
                          _c("template", { slot: "default" }, [
                            _c("div", { staticClass: "tips-content" }, [
                              _c("ul", [
                                _c("li", [
                                  _c("strong", [_vm._v("中奖率：")]),
                                  _vm._v("=0 表示永远抽不到此奖项"),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("中奖率加和：")]),
                                  _vm._v("必须等于 100%"),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("奖品总数：")]),
                                  _vm._v(
                                    "该奖项放出的总数，抽完后前端中奖率自动归 0"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("总数设置：")]),
                                  _vm._v(
                                    "=0 表示无限制；周边奖品总数必须大于 0"
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "rate-summary" }, [
                        _c("span", { staticClass: "rate-label" }, [
                          _vm._v("中奖率总和"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "rate-value",
                            class: {
                              "rate-valid": _vm.totalRate == 100,
                              "rate-invalid": _vm.totalRate != 100,
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.totalRate) +
                                "%\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.totalRate != 100
                          ? _c("span", { staticClass: "rate-status" }, [
                              _vm._v("（需等于100%）"),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "awards-grid" },
                        _vm._l(_vm.formData.pack, function (item, index) {
                          return _c(
                            "div",
                            { key: "award-" + index, staticClass: "award" },
                            [
                              _c(
                                "span",
                                { staticClass: "award-inline-label" },
                                [_vm._v("奖品：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "award-image-wrapper" },
                                [
                                  _c("image-upload", {
                                    staticClass: "award-image-upload",
                                    attrs: { prefix: _vm.imagePrefix },
                                    model: {
                                      value: item.imgUrl,
                                      callback: function ($$v) {
                                        _vm.$set(item, "imgUrl", $$v)
                                      },
                                      expression: "item.imgUrl",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "award-inline-label" },
                                [_vm._v("icon：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "award-image-wrapper" },
                                [
                                  _c("image-upload", {
                                    staticClass: "award-image-upload",
                                    attrs: { prefix: _vm.imagePrefix },
                                    model: {
                                      value: item.iconUrl,
                                      callback: function ($$v) {
                                        _vm.$set(item, "iconUrl", $$v)
                                      },
                                      expression: "item.iconUrl",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "award-inline-label" },
                                [_vm._v("中奖率：")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "award-rate-input",
                                attrs: { placeholder: "0" },
                                on: {
                                  blur: function ($event) {
                                    return _vm.handleRateInput(index)
                                  },
                                },
                                model: {
                                  value: item.rate,
                                  callback: function ($$v) {
                                    _vm.$set(item, "rate", $$v)
                                  },
                                  expression: "item.rate",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "award-input-suffix" },
                                [_vm._v("%")]
                              ),
                              _vm._v(" "),
                              item.awardType !== 0 && _vm.maxRates[index] < 100
                                ? _c(
                                    "span",
                                    { staticClass: "rate-limit-tip" },
                                    [
                                      _vm._v(
                                        "\n                (最高" +
                                          _vm._s(_vm.maxRates[index]) +
                                          "%)\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "award-inline-label" },
                                [_vm._v("总数：")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "award-total-input",
                                attrs: { placeholder: "0" },
                                model: {
                                  value: item.total,
                                  callback: function ($$v) {
                                    _vm.$set(item, "total", _vm._n($$v))
                                  },
                                  expression: "item.total",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "award-input-suffix" },
                                [
                                  _vm._v(
                                    "(次数:" + _vm._s(item.hitTimes || 0) + ")"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "award-inline-label" },
                                [_vm._v("\n                ：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  staticClass: "award-type-select",
                                  attrs: { placeholder: "请选择..." },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleAwardTypeChange(index)
                                    },
                                  },
                                  model: {
                                    value: item.awardType,
                                    callback: function ($$v) {
                                      _vm.$set(item, "awardType", $$v)
                                    },
                                    expression: "item.awardType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "谢谢参与", value: 0 },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "优惠券", value: 1 },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "积分", value: 2 },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "周边", value: 3 },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "再来一次", value: 4 },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              item.awardType === 1
                                ? [
                                    _c(
                                      "span",
                                      { staticClass: "award-inline-label" },
                                      [_vm._v("优惠券：")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "award-bonus-select",
                                        attrs: {
                                          placeholder: "请选择优惠券",
                                          filterable: "",
                                          clearable: "",
                                        },
                                        model: {
                                          value: item.typeId,
                                          callback: function ($$v) {
                                            _vm.$set(item, "typeId", $$v)
                                          },
                                          expression: "item.typeId",
                                        },
                                      },
                                      _vm._l(_vm.bonusList, function (bonus) {
                                        return _c("el-option", {
                                          key: bonus.typeId,
                                          attrs: {
                                            label:
                                              "[" +
                                              bonus.typeId +
                                              "] " +
                                              bonus.typeName,
                                            value: bonus.typeId,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "award-inline-label" },
                                      [_vm._v("数量：")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "award-num-input",
                                      attrs: { placeholder: "数量" },
                                      model: {
                                        value: item.num,
                                        callback: function ($$v) {
                                          _vm.$set(item, "num", _vm._n($$v))
                                        },
                                        expression: "item.num",
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              item.awardType === 2
                                ? [
                                    _c(
                                      "span",
                                      { staticClass: "award-inline-label" },
                                      [_vm._v("数量：")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "award-num-input",
                                      attrs: { placeholder: "积分数量" },
                                      model: {
                                        value: item.num,
                                        callback: function ($$v) {
                                          _vm.$set(item, "num", _vm._n($$v))
                                        },
                                        expression: "item.num",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "award-input-suffix" },
                                      [_vm._v("积分")]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              item.awardType === 3
                                ? [
                                    _c(
                                      "span",
                                      { staticClass: "award-inline-label" },
                                      [_vm._v("数量：")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "award-num-input",
                                      attrs: { placeholder: "数量" },
                                      model: {
                                        value: item.num,
                                        callback: function ($$v) {
                                          _vm.$set(item, "num", _vm._n($$v))
                                        },
                                        expression: "item.num",
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "medium",
                                loading: _vm.submitLoading,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [_vm._v("\n              确认\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "medium",
                                loading: _vm.submitLoading,
                              },
                              on: { click: _vm.handleValidate },
                            },
                            [_vm._v("\n              校验\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "medium" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("\n              重置\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.goodsSelectorVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.goodsSelectorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "goods-selector" },
            [
              _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "菜品编码/菜品名称", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.queryGoodsList($event)
                      },
                    },
                    model: {
                      value: _vm.goodsListQuery.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.goodsListQuery, "keywords", $$v)
                      },
                      expression: "goodsListQuery.keywords",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-cascader", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      options: _vm.categoryOptions,
                      props: {
                        value: "id",
                        label: "categoryName",
                        leaf: "leaf",
                        checkStrictly: true,
                      },
                      placeholder: "菜品分类",
                      clearable: "",
                    },
                    model: {
                      value: _vm.goodsListQuery.categories,
                      callback: function ($$v) {
                        _vm.$set(_vm.goodsListQuery, "categories", $$v)
                      },
                      expression: "goodsListQuery.categories",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "菜品类型", clearable: "" },
                      model: {
                        value: _vm.goodsListQuery.goodsType,
                        callback: function ($$v) {
                          _vm.$set(_vm.goodsListQuery, "goodsType", $$v)
                        },
                        expression: "goodsListQuery.goodsType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "单品", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "套餐", value: "2" } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.queryGoodsList },
                    },
                    [_vm._v("\n          搜索\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.goodsListData,
                    border: "",
                    stripe: "",
                    "max-height": "400",
                  },
                  on: { "selection-change": _vm.handleGoodsSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "55",
                      selectable: _vm.checkGoodsSelectable,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "菜品编码",
                      prop: "goodsCode",
                      width: "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "菜品名称",
                      prop: "goodsName",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "菜品类型", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.goodsType == 1
                              ? _c("span", [_vm._v("单品")])
                              : _vm._e(),
                            _vm._v(" "),
                            row.goodsType == 2
                              ? _c("span", [_vm._v("套餐")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属大类",
                      prop: "categoryFirstName",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属小类",
                      prop: "categorySecondName",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商品图", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            !row.goodsThumbnailUrl ||
                            row.goodsThumbnailUrl === ""
                              ? _c("span", [_vm._v("未上传图片")])
                              : _c(
                                  "el-image",
                                  {
                                    staticStyle: {
                                      width: "60px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      src: _vm.getGoodsImageUrl(
                                        row.goodsThumbnailUrl
                                      ),
                                      fit: "contain",
                                      "preview-src-list": [
                                        _vm.getGoodsImageUrl(
                                          row.goodsThumbnailUrl
                                        ),
                                      ],
                                      "preview-teleported": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "image-slot",
                                        attrs: { slot: "error" },
                                        slot: "error",
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-picture-outline",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "16px", "text-align": "right" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.goodsListQuery.page,
                      "page-size": _vm.goodsListQuery.limit,
                      total: _vm.goodsListTotal,
                      layout: "total, prev, pager, next",
                    },
                    on: { "current-change": _vm.handleGoodsPageChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.goodsSelectorVisible = false
                    },
                  },
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmGoodsSelection },
                },
                [_vm._v("\n        确定\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择菜品小类",
            visible: _vm.categorySelectorVisible,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.categorySelectorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "category-selector-dialog" },
            [
              _c("el-tree", {
                ref: "categoryTree",
                staticStyle: { "max-height": "400px", "overflow-y": "auto" },
                attrs: {
                  data: _vm.categoryOptions,
                  "show-checkbox": "",
                  "node-key": "id",
                  "default-checked-keys": _vm.tempCategoryList,
                  props: { label: "label", children: "children" },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.categorySelectorVisible = false
                    },
                  },
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmCategorySelection },
                },
                [_vm._v("\n        确定\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择门店",
            visible: _vm.storeSelectorVisible,
            width: "800px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.storeSelectorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "store-selector-dialog" },
            [
              _c(
                "div",
                { staticClass: "store-selector-toolbar" },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      placeholder: "请输入关键字进行筛选",
                      "prefix-icon": "el-icon-search",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.storeSearchText,
                      callback: function ($$v) {
                        _vm.storeSearchText = $$v
                      },
                      expression: "storeSearchText",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "12px" },
                      attrs: { size: "small", type: "text" },
                      on: { click: _vm.selectAllStores },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.isAllStoresSelected ? "取消全选" : "全选"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "storeTreeDialog",
                staticClass: "store-tree-dialog",
                attrs: {
                  data: _vm.storeTreeData,
                  "show-checkbox": "",
                  "node-key": "id",
                  "default-expanded-keys": _vm.storeExpandedKeys,
                  "default-checked-keys": _vm.storeCheckedKeys,
                  props: _vm.storeTreeProps,
                  "filter-node-method": _vm.filterStoreNode,
                },
                on: { "check-change": _vm.handleStoreCheckInDialog },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.storeSelectorVisible = false
                    },
                  },
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmStoreSelection },
                },
                [_vm._v("\n        确定\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }